module.exports = __webpack_public_path__ + "img/title6_1.c52fe464.png";